import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";

import { Container, Col, Row, Button, Table } from "react-bootstrap";
import { ArrowLeftCircle, Printer } from 'react-bootstrap-icons';

import moment from 'moment';

import NavbarComponent from '../components/NavbarComponent';
import AlertErrorComponent from '../components/AlertErrorComponent';
import LoadingComponent from '../components/LoadingComponent';
import FooterComponent from '../components/FooterComponent';

import {
     NO_USER_FOUND,
    FAILED_AUTHENTICATE_TOKEN,
} from "../constants/ApiResult";

import { BRANCHES, SUPPLIERS, PRODUCTS, UNITS } from '../constants/GlobalConstant';

import {
getPurchaseOrdersItemsByPOId
} from "../services/PurchaseOrder";

import I18N from "../js/i18n";
//import {i18n} from "../js/global";

class PickingList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            alertErrorMessage:'',
            isLoading:true,
            data:[],
            suppliers:[],
            poApprovedChecked:[]
        }
    }

    componentDidMount() {
       if(this.props.poApprovedChecked.length === 0) {
            this.setState({
                isLoading:false,
                alertErrorMessage:"No purchase orders selected for picking list"
            });
       } else if(!this.props.auth.isInternalSupplier && this.props.auth.mode !== "supplier") {
            this.setState({
                isLoading:false,
                alertErrorMessage:"Account is not configured as internal supplier"
            });
       } else {
        this.initData();
       }
    }

    initData = () => {
        let poApprovedChecked = this.props.poApprovedChecked.filter( (poId) => this.props.approvedDataPO.findIndex( (po) => po.POId === poId ) > -1 );
        if(poApprovedChecked.length) {
            this.setState({
                poApprovedChecked:poApprovedChecked
            }, () => {
                this.getSuppliers();
                //if(this.isPoApprovedCheckedInternalSupplier() || this.props.auth.mode === 'supplier') {
                //    this.getPODetails();
                //}
            });
        } else {
            this.setState({
                isLoading:false,
                alertErrorMessage:"No purchase orders selected for picking list"
            });
        }
    }

// API

    handleResponseAPI = (data) => {
        if (
            [NO_USER_FOUND, FAILED_AUTHENTICATE_TOKEN].indexOf(
            data
            ) > -1
        ) {
            this.setState({
            isLoading: false,
            authError: true,
            });
            return;
        }
    }

    handleErrorAPI = (err, msg) => {
        if(err) {
            console.error(err);
        }
        this.setState({
            isLoading:false,
            alertErrorMessage:msg,
        });
    }

    getPODetails = () => {
        this.setState({
            isLoading:true
        }, async () => {
            try {
                let response = await getPurchaseOrdersItemsByPOId({
                    token:this.props.auth.token,
                    poId:JSON.stringify(this.state.poApprovedChecked)
                });

                this.handleResponseAPI(response.data.result);

                let res = response.data.data;

                if(res.length > 0) {
                    // group by groupId
                    let data = [];
                    res.forEach( (obj) => {
                        let index = data.findIndex( (product) => product.GoodsId === obj.GoodsId && product.GoodsFormatId === obj.GoodsFormatId );
                        if(index > -1) {
                            data[index].Num = data[index].Num + obj.Num;
                        } else {
                            data.push(obj);
                        }
                    });
                    this.setState({
                        isLoading:false,
                        alertErrorMessage:'',
                        data:data
                    });
                } else {
                    this.handleErrorAPI(null, 'Bad Request (400)');
                }
            } catch(err) {
                // handle error
                this.handleErrorAPI(null, 'Bad Request (500)');
            }
        });
    }

    getPOBySupplier = (supplierId) => {
        let data = JSON.parse(JSON.stringify(this.props.approvedDataPO));
        let dataFiltered = data.filter( (po) => this.state.poApprovedChecked.indexOf(po.POId) > -1 && po.supplierId === supplierId );
        return dataFiltered; 
    }

    htmlSummaryTableRows = (supplierId) => {
        let html = this.getPOBySupplier(supplierId).map( (po) => {
            return (
                <tr>
                    <td>{po.OrderName}</td>
                    <td>{moment(po.CreateDate).utc().format("DD MMM YYYY")}</td>
                    <td>{moment(po.CreateDate).utc().format("LT")}</td>
                    <td>
                        <I18N 
                            type={BRANCHES} 
                            value={{
                                "businessId":this.props.auth.businessId,
                                "branchId":po.BranchId
                            }} 
                            property="BranchName" 
                            def={po.BranchName}
                        />
                    </td>
                </tr>
            );
        });

        return (
        <tbody>
            {html}
        </tbody>
        );       
    }

    getPOItemsBySupplier = (supplierId) => {
        return this.state.data.filter( (row) => row.SupplierId === supplierId );
    }

    htmlItemsTables = (supplierId) => {
        let data = this.getPOItemsBySupplier(supplierId);
        let group = [];

        let html = data.map ( (obj, index) => {
 
            if(group.indexOf(obj.groupId) === -1) {
                group.push(obj.groupId);

                let tableItems = data.filter( (product) => product.groupId === obj.groupId && product.Num > 0 );
                tableItems.sort((a, b) => (a.GoodsCode > b.GoodsCode) ? 1 : -1);

                return (
                    <div key={index}>
                    {obj.groupId && <h4 className="mt-3">{obj.groupId}</h4>}
                    <Table bordered hover size="sm" className="print-table-text-lg">
                    <thead>
                        <tr>
                            <th width="7.5%"><I18N type="ui" path="PRODUCT_CODE" def="編號"/></th>
                            <th width="27.5%"><I18N type="ui" path="PRODUCT_NAME" def="貨品名稱"/></th>
                            <th width="5%"><I18N type="ui" path="PRODUCT_QUANTITY" def="數量"/></th>
                            <th width="10%"><I18N type="ui" path="PRODUCT_PACKAGING_UNIT" def="單位"/></th>
                            <th className="bg-dark">&nbsp;</th>
                            <th width="7.5%"><I18N type="ui" path="PRODUCT_CODE" def="編號"/></th>
                            <th width="27.5%"><I18N type="ui" path="PRODUCT_NAME" def="貨品名稱"/></th>
                            <th width="5%"><I18N type="ui" path="PRODUCT_QUANTITY" def="數量"/></th>
                            <th width="10%"><I18N type="ui" path="PRODUCT_PACKAGING_UNIT" def="單位"/></th>
                        </tr>
                    </thead>
                        {this.htmlItemsTableRows(tableItems)}
                    </Table> 
                    </div>
                );
            } else return "";
        });
        return html;
    }

    htmlItemsTableRows = (rows) => {

        let data = [];
        let array = [];
        
        rows.forEach( (row, index) => {    

            array.push(row);
            if(Math.abs(index % 2) === 1 || rows.length === 1) {
                if(array.length === 1) {
                    array.push({
                        GoodsCode:'',
                        GoodsName:'',
                        Num:'',
                        GoodsFormatNumber:'',
                        GoodsFormatName:'',
                        UnitName:''
                    })
                }
                data.push(array);
                array = [];
            }

            // odd number of rows and its the last row
            if(Math.abs(rows.length % 2) === 1 && rows.length > 1 && (rows.length - 1 === index)) {
                data.push(array);
            }
            
        });

        let html = data.map ( (product, index) => {
            return (
                <tbody>
                    <tr>
                        <td>{product[0] && product[0].GoodsCode}</td>
                        <td>
                            {product[0] && 
                            <I18N 
                            type={PRODUCTS}
                            value={product[0].GoodsId} 
                            def={product[0].GoodsName} />
                            }
                        </td>
                        <td>{product[0] && product[0].Num}</td>
                        <td className="text-nowrap">
                            {
                                product[0] && 
                                <I18N type={UNITS} value={product[0].GoodsFormatName} def={product[0].GoodsFormatName}/> 
                            }
                        </td>
                        <td className="bg-dark">&nbsp;</td>
                        <td>{product[1] && product[1].GoodsCode}</td>
                        <td>
                            {product[1] && 
                            <I18N 
                            type={PRODUCTS}
                            value={product[1].GoodsId} 
                            def={product[1].GoodsName} />
                            }
                        </td>
                        <td>{product[1] && product[1].Num}</td>
                        <td className="text-nowrap">
                        {
                                product[1] && 
                                <I18N type={UNITS} value={product[1].GoodsFormatName} def={product[1].GoodsFormatName}/> 
                            }                     
                        </td>
                    </tr>
                </tbody>
            );
        });
        return html;
    }

    isPoApprovedCheckedInternalSupplier = () => {
        let internal = true;
        this.state.poApprovedChecked.forEach( (poId) => {
            let data = this.props.approvedDataPO.filter( (po) => po.POId === poId )[0];
            if(data.supplierBusinessId === 0) {
                internal = false;
                this.setState({
                    isLoading:false,
                    alertErrorMessage:'Selected purchase orders must belong to the internal supplier'
                });
            }
        });
        return internal;
    }

    /*
    isPoApprovedCheckedSameSupplier = () => {
        let supplierId;
        let error = false;
        this.props.poApprovedChecked.forEach( (poId) => {
            let data = this.props.approvedDataPO.filter( (po) => po.POId === poId )[0];
            if(!supplierId) {
                supplierId = data.supplierId;
            } else {
                if(supplierId !== data.supplierId) {
                    error = true;
                    this.setState({
                        alertErrorMessage:'Selected purchase orders must belong to the same supplier to print picking list'
                    });
                }
            }
        });
        if(!error) {
            this.setState({
                alertErrorMessage:''
            });
            return true;
        }
        return false;
   }
   */

    getSuppliers = () => {
        let suppliers = [];
        this.state.poApprovedChecked.forEach( (poId) => {
            let data = this.props.approvedDataPO.filter( (po) => po.POId === poId )[0];
            if(suppliers.findIndex( (supplier) => data.supplierId === supplier.supplierId) === -1 ) {
                suppliers.push({"supplierId":data.supplierId, "supplierName":data.SupplierName});
            }
        });

        this.setState({
            suppliers:suppliers
        }, () => {
            if(this.isPoApprovedCheckedInternalSupplier() || this.props.auth.mode === 'supplier') {
                this.getPODetails();
            }
        })
    }

    getSupplierName = () => {
        if(this.state.poApprovedChecked.length) {
            let data = this.props.approvedDataPO.filter( (po) => po.POId === this.state.poApprovedChecked[0])[0];
            if(data.SupplierName) {
                return data.SupplierName;
            }
        }
        return;
    }

    getHTML = () => {
        return this.state.suppliers.map( (supplier, index) => {
            return (
                <>
                {index > 0 && <div className="page-break" />}
                <div className="mt-4">
                    <h2>
                        <I18N 
                            type={SUPPLIERS} 
                            value={supplier.supplierId}
                            property="SupplierName"
                            def={supplier.supplierName}
                        />
                    </h2>
                    {this.getInnerHTML(supplier.supplierId)}
                </div>
                </>
            );
        });
    }

    getInnerHTML = (supplierId) => {
        return (
            <>
                <div className="mt-4">
                    <h3 className="text-info"><I18N type="ui" path="PURCHASE_ORDERS_SUMMARY" def="Purchase Orders Summary"/></h3>
                    <Table bordered hover size="sm" className="print-table-text-lg">
                    <thead>
                        <tr>
                            <th><I18N type="ui" path="PURCHASE_ORDER_NUMBER" def="採購單號"/></th>
                            <th><I18N type="ui" path="ORDER_DATE" def="訂購日期"/></th>
                            <th><I18N type="ui" path="ORDER_TIME" def="訂購時間"/></th>
                            <th><I18N type="ui" path="BRANCH" def="餐廳"/></th>
                        </tr>
                    </thead>
                    {this.htmlSummaryTableRows(supplierId)}
                    </Table>
                
                    <h3 className="text-info"><I18N type="ui" path="ITEMS" def="Items"/></h3>
                    {this.htmlItemsTables(supplierId)}
                </div>
            </>
        );
    }

    render() {
        return (
            <>
            <Container fluid className="p-0">
                {this.props.auth.isLogin && <NavbarComponent />}
                <Container className="print-layout">
                    {this.state.isLoading
                    ?
                        <LoadingComponent />
                    :
                    <>
                        <Row className="no-print">
                            <Col xs={12}>
                                <div className="float-end mt-4">
                                    <div>
                                        <Button variant="link" className="px-0 me-4" onClick={ () => this.props.history.push('/purchase-orders/approved') }>
                                            <ArrowLeftCircle size={16} className="mb-1 me-1" /> Go Back
                                        </Button> 
                                        <Button variant="link" className="px-0" onClick={ () => window.print() }>
                                            <Printer size={16} className="mb-1 me-1" /> Print
                                        </Button> 
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row className="portrait-section">
                            <Col xs={12}>
                                <div className="mt-4">
                                    <h1><I18N type="ui" path="PICKING_LIST" def="Picking List"/></h1>
                                </div>
                                {
                                    this.state.alertErrorMessage
                                    ?
                                        <div className="mt-4">
                                            <AlertErrorComponent label={this.state.alertErrorMessage} />
                                        </div>
                                    :
                                    <>
                                    <div className="mt-4">
                                        <p className="mt-4">
                                            Consolidated picking list printed on {moment().format('LT - Do MMMM YYYY')}
                                        </p>
                                    </div>
                                    {this.getHTML()}
                                    </>
                                }
                            </Col>
                        </Row>
                    </>
                    }
                </Container>
            </Container>
            <FooterComponent />
            </>
        )
    }

}

const mapStateToProps = state => {
    const {
        auth, 
        poApprovedChecked, 
        approvedDataPO,
        poSupplier
    } = state;

    return { 
        auth: auth, 
        poApprovedChecked:poApprovedChecked,
        approvedDataPO:approvedDataPO,
        poSupplier:poSupplier
    };
};

export default connect(mapStateToProps, null)(withRouter(PickingList));